import Immutable from 'immutable';

import { objectToQueryString } from "../../helpers/commonHelper";

const LOAD = 'video/LOAD';
const LOAD_SUCCESS = 'video/LOAD_SUCCESS';
const DOWNLOAD_SUCCESS = 'video/DOWNLOAD_SUCCESS';
const LOAD_FAIL = 'video/LOAD_FAIL';
const UPLOAD_YOUTUBE_SUCCESS = 'auth/UPLOAD_YOUTUBE_SUCCESS';
const GET_CHANNEL_SUCCESS = 'auth/GET_CHANNEL_SUCCESS';
const POST_AMAZON_SUCCESS = 'auth/POST_AMAZON_SUCCESS';
const UPDATE_VIDEO_SUCCESS = 'auth/UPDATE_VIDEO_SUCCESS';
const EDIT_VIDEO_SUCCESS = 'auth/EDIT_VIDEO_SUCCESS';
const UPDATE_VIDEO_FIELDS = 'plugin/UPDATE_VIDEO_FIELDS';

const UPDATE_VIDEO_COUNT = 'video/UPDATE_VIDEO_COUNT';
const UPDATE_VIDEO_COUNT_SUCCESS = 'video/UPDATE_VIDEO_COUNT_SUCCESS';
const UPDATE_VIDEO_COUNT_FAIL = 'video/UPDATE_VIDEO_COUNT_FAIL';

const internal = {};

const initialState = Immutable.fromJS({
  Videos: [],
  loading: false,
  hasMore: true,
  errorMessage: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('loading', true);

    case LOAD_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
      return state
        .set('loading', false)
        .set('hasMore', action.hasMore)
        .set('Videos', action.Videos);

    case UPDATE_VIDEO_COUNT:
      return state
            .set('errorMessage', null);

    case UPDATE_VIDEO_COUNT_FAIL:
      return state
        .set('errorMessage', action.errorMessage);

    case UPDATE_VIDEO_COUNT_SUCCESS:
      return state
        .set('errorMessage', null);

    case DOWNLOAD_SUCCESS:
      return state
        .set('loading', false);

    case UPLOAD_YOUTUBE_SUCCESS:
      return state
        .set('loading', false);

    case GET_CHANNEL_SUCCESS:
      return state
        .set('loading', false);

    case UPDATE_VIDEO_SUCCESS:
      return state
      .set('loading',false)
      .set('Videos', action.Videos);

    case POST_AMAZON_SUCCESS:
      return state
      .set('loading',false)
      .set('Videos', action.Videos);

    case UPDATE_VIDEO_FIELDS:
      return state
        .set('message', action.message)
        .set('loading', false);

    case EDIT_VIDEO_SUCCESS:
      return state
      .set('loading',false)
      .set('Videos', action.Videos);

      break;

    default:
      return state;
  }
}

export const getVideos = (page, uuid, campaignId) => async (dispatch, getState, api) => {
  let pageNum = page || 1;
  let initialVideos = [];
  if (pageNum > 1) {
    initialVideos = getState().get('video').get('Videos');
  }
  dispatch({ type: LOAD });

  try {
    const res = await api.get('/videos', { params: { pageNum, uuid, campaignId }});
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }

    let AllVideos = initialVideos.size == 0 ? [] : initialVideos;

    if (res.length > 0) {
      AllVideos = AllVideos.concat(res);
    }

    dispatch({ type: LOAD_SUCCESS, hasMore: res.length < 50 ? false : true, Videos: AllVideos });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const deleteVideo = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let initialVideos = getState().get('video').get('Videos');
  try {
    const res = await api.put('/videos', {data});
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    let updatedVideos = initialVideos.filter(function(video) {
      return video.id !== data.id
    });
    dispatch({ type: LOAD_SUCCESS, Videos: updatedVideos });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const updateVideoTags = (id) => async (dispatch, getState, api) => {
  let initialVideos = getState().get('video').get('Videos');
  const updatedVideos = initialVideos.map(v => {
    v.video_tags = Object.assign([], v.video_tags.filter(vt => vt.tagId !== id));
    return v;
  })
  dispatch({ type: LOAD_SUCCESS, Videos: Object.assign([], updatedVideos)});
};

export const updateVideoDataById = (id, data, showMsg) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const keyString = internal.capitalizeFirstLetter(Object.keys(data.data)[0]);
    const key = keyString.replace(/([A-Z])/g, ' $1').trim();
    await api.put(`/videos/fields/${id}`, { data });
    dispatch({
      type: UPDATE_VIDEO_FIELDS,
      message: (showMsg) ? `${key} has been successfully saved.` : ''
    });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const downloadVideos = (id) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/videos/download/'+id);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: DOWNLOAD_SUCCESS });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const addVideoTags = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  const userId = data.userId;
  delete data.userId;
  try {
    const res = await api.post('/videos/tags', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const videos = getState().get('video').get('Videos');
    const index = videos.findIndex(v => v.id === data.videoId);
    const tags = videos[index].video_tags;

    const newTag = Object.assign({}, res, { tag: { id: res.tagId, tagName: data.tagName, userId } });
    tags.push(newTag);
    videos[index].video_tags = Object.assign([], tags);

    dispatch({ type: LOAD_SUCCESS, Videos: videos });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const deleteVideoTags = (data, videoId, pluginTags) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.put('/videos/tags/delete', {data});
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    let videos = getState().get('video').get('Videos');
    const videoIndex = videos.findIndex(v => v.id === videoId);
    const video = videos[videoIndex];

    video.video_tags = Object.assign([], video.video_tags.filter(vt => vt.id !== data.id));

    const videoHasPluginTag = pluginTags.some(item => video.video_tags.map(x => x.tagId).includes(item));

    videos[videoIndex] = Object.assign({}, video);
    if(pluginTags && pluginTags.length > 0 && !videoHasPluginTag) {
      videos = videos.filter(v => v.id !== videoId);
    }
    dispatch({ type: LOAD_SUCCESS, Videos: videos });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

export const getCampaignVideos = (campaignId) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/videoslist/'+campaignId);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, Videos: res, MoreVideoResults: [] });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const uploadVideoYouTube = (data) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.put('/videos/youtube' , {data});
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: UPLOAD_YOUTUBE_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getYouTubeChannelDetails = (token) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });

  try {
    const res = await api.get('/videos/youtube/channels/' + token);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: GET_CHANNEL_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const postAmazonAsins = (data,key) => async (dispatch, getState, api) => {
  let Videos = [];
  dispatch({ type: LOAD });
  Videos = getState().get('video').get('Videos');
  try {
    const res = await api.post('/videos/amazon' , {data});
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    Videos[key].amazon_video = res;
    dispatch({ type: POST_AMAZON_SUCCESS , Videos : Videos  });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const postVideoEdits = (data,key) => async (dispatch, getState, api) => {
  let Videos = [];
  dispatch({ type: LOAD });
  Videos = getState().get('video').get('Videos');
  try {
    const res = await api.post('/videos/request/edit' , {data});
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    Videos[key].edit_video = res;
    dispatch({ type: EDIT_VIDEO_SUCCESS , Videos : Videos  });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const updateVideoThumbnail = (data,videoKey) => async (dispatch, getState, api) => {
  let Videos = [];
  dispatch({ type: LOAD });
  Videos = getState().get('video').get('Videos');
  try {
    const res = await api.put('/videos/update' , {data});
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    Videos[videoKey].thumbFileType = res.result.thumbFileType;
    Videos[videoKey].thumbFileName = res.result.thumbFileName;
    setTimeout(function(){
      dispatch({ type: UPDATE_VIDEO_SUCCESS , Videos : Videos  });
    }, 5000);

  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const updateVideoViewCount = (id) => async (dispatch, getState, api) => {
  dispatch({ type: UPDATE_VIDEO_COUNT });
  try {
    let data = {
      id: id
    };
    const res = await api.put('/videos/view/count' , {data});
    if (res.message) {
      dispatch({ type: UPDATE_VIDEO_COUNT_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: UPDATE_VIDEO_COUNT_SUCCESS });
  } catch (error) {
    dispatch({ type: UPDATE_VIDEO_COUNT_FAIL, errorMessage: error });
  }
};

internal.capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getVideosByTag = ({
  page = 0,
  tagId,
  videoPerPage = 50,
  orderBy,
} = {}) => async (dispatch, getState, api) => {
  let initialVideos = [];
  if (page > 0) {
    initialVideos = getState().get("video").get("Videos");
  }
  dispatch({ type: LOAD });

  const query = {
    page,
    perPage: videoPerPage,
    order: orderBy,
  };

  const queryString = objectToQueryString(query);

  try {
    const res = await api.get(`/videos/get-from-tag/${tagId}?${queryString}`);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return [undefined, undefined];
    }

    let AllVideos = initialVideos.size === 0 ? [] : initialVideos;

    const videos = res.data;

    if (videos.length > 0) {
      AllVideos = AllVideos.concat(videos);
    }

    const hasMore = videos.length < videoPerPage ? false : true;

    dispatch({ type: LOAD_SUCCESS, hasMore, Videos: AllVideos });

    return [AllVideos, hasMore];
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const createEditVideo = (data) => (dispatch, getState, api) =>
  api.post("edit-video", { data });



// WEBPACK FOOTER //
// ./src/redux/modules/video.js